import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  constructor(
		public dialogRef: MatDialogRef<AlertComponent>,
  ) { }

  ngOnInit() {
  }

  /**
   * Closes modal.
   */
  confirm(): void {
		this.dialogRef.close();
	}

}
